import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PassengerAdultChild } from '@src/app/core/models/ib-checkin-apis/ib-checkin-apis.model';
import { CheckinAppConstants } from '@src/components/routing/ib-check-in-constants';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';

@Injectable({
    providedIn: 'root'
})
export class IbUtilsService {
    constructor (
        private TranslateService: TranslateService,
        private CommonsSessionStorageService: CommonsSessionStorageService
    ){}

    setTitlePage (title, time) {
        time = (time !== undefined || time!== null) ? time : 0;
        setTimeout(() => {
            window.document.title = this.TranslateService.instant(title);
        }, time);
    }

    isUserLogged () {
        return this.CommonsSessionStorageService.get('userLogged');
    }

    getPassengerType (passengerId: string): PassengerAdultChild {
        let cachedInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        const passengerType: PassengerAdultChild = cachedInfo.passengers.find(passenger => passengerId === passenger.id)?.type || CheckinAppConstants.PASSENGERS_TYPES.ADULT;
        return passengerType || CheckinAppConstants.PASSENGERS_TYPES.ADULT as 'ADULT';
    }

    updatePassengersSelected (passengersIds: number[] = []): number[] {
        const passengersNOAPIS: number[] = this.getPassegersNOAPIS();
        const newPassengersSelected = [...new Set([...passengersNOAPIS, ...passengersIds])];
        this.CommonsSessionStorageService.set('passengersSelected', newPassengersSelected);
        return newPassengersSelected;
    }

    getPassegersNOAPIS (): number[] {
        return this.CommonsSessionStorageService.get('passengersNOAPIS') || [];
    }

    isResolutionToMobile (innerWidth: number = 768): boolean {
        return window.innerWidth < innerWidth;
    }
}
